function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 12,
  r: 1
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 5,
  r: 1
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 19,
  r: 1
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 12,
  r: 1
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 5,
  r: 1
});
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 19,
  r: 1
});
var SvgGripVertical = function SvgGripVertical(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGripVertical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GripVertical.f93d0c98.svg";
export { ForwardRef as ReactComponent };